import { useState, useEffect } from 'react';
import '../styles/WeatherEvents.css';
import { Check, RefreshCw } from 'lucide-react';

const WeatherEvents = ({ caseData }) => {
    const [events, setEvents] = useState([]);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [showRefreshCheck, setShowRefreshCheck] = useState(false);

    const fetchWeatherEvents = async (refresh = false) => {
        setIsRefreshing(true);
        const response = await fetch(`https://api.casedb.co/hailtrace-report.php?contact_id=${caseData?.case?.contact_id}&refresh=${refresh}`, { credentials: 'include' });
        const data = await response.json();
        if (data.success) {
            setEvents(data?.hailtrace?.data?.filterWeatherEvents?.results || []);
        }
        setIsRefreshing(false);
        setShowRefreshCheck(true);
        setTimeout(() => setShowRefreshCheck(false), 300);
    }

    useEffect(() => {
        fetchWeatherEvents();
    }, [caseData?.case?.contact_id]);

    return (
        <div className='case-section case-weather-events'>
            <div className='toc-header'>
                <h3>Weather Events</h3>
                <div className='toc-header-actions'>
                    <div className='reload small-text' onClick={() => fetchWeatherEvents(true)}>
                        {showRefreshCheck ? (
                            <Check size={14} />
                        ) : (
                            <RefreshCw size={14} className={isRefreshing ? 'spinner small' : undefined} />
                        )}
                        Refresh
                    </div>
                </div>
            </div>
            <table className='weather-events'>
                <thead>
                    <tr className='small-text'>
                        <th>Date</th>
                        <th>Event Type</th>
                        <th>Meteorologist Magnitude</th>
                        <th>Algorithm Magnitude</th>
                    </tr>
                </thead>
                <tbody>
                    {events.map((event, index) => {
                        const [year, month, day] = event.eventDate.split('-').map(Number);
                        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                        const formattedDate = `${monthNames[month - 1]} ${String(day).padStart(2, '0')}, ${year}`;
                        return (
                        <tr key={index} className='subtext'>
                            <td>{formattedDate}</td>
                            <td>{event.types[0] === "METEOROLOGIST_WIND_SPEED" ? 'Wind' : (event.types[0] === 'ALGORITHM_HAIL_SIZE' || event.types[0] === 'METEOROLOGIST_HAIL_SIZE') ? 'Hail' : event.types.join(", ")}</td>
                            <td>{event.maxMeteorologistWindSpeedMPH ? `${event.maxMeteorologistWindSpeedMPH} MPH` : '-'}</td>
                            <td>{(event.maxMeteorologistHailSize || event.maxAlgorithmHailSize) ? `${event.maxAlgorithmHailSize || event.maxMeteorologistHailSize} in` : '-'}</td>
                        </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default WeatherEvents;